<template>
  <article
    :class="['category', `category--${category?.ContentPosition}`]"
  >
    <component
      :is="getElement"
      class="category__link"
      :to="category?.File?.Link"
    >
      <div class="category__visual">
        <picture
          v-if="category?.File?.Media?.url && category?.File?.Media?.mime?.includes('image')"
          class="category__picture"
        >
          <source
            :srcset="desktopImage"
            media="(min-width: 1024px)"
          >
          <source
            :srcset="mobileImage"
          >
          <img
            class="category__image"
            :src="desktopImage"
            :alt="category?.File?.Media?.alternativeText || category?.Name || ''"
            :width="category?.File?.Media?.width"
            :height="category?.File?.Media?.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'low' : 'high'"
            :decoding="lazy ? 'async' : 'sync'"
          >
        </picture>
        <div
          v-else-if="category?.File?.Media?.url && category?.File?.Media?.mime?.includes('video')"
          class="category__video"
        >
          <UiVideo
            v-if="category?.File?.Media?.url"
            :class="{ 'mq--desktop-plus': category?.File?.Media?.url && category?.File?.MediaMobile?.url }"
            :src="category?.File?.Media?.url"
            :alt="category?.File?.Media?.alternativeText || category?.Name"
            :width="category?.File?.Media?.width"
            :height="category?.File?.Media?.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'auto' : 'high'"
            :controls="false"
            autoplay
            muted
            loop
          />
          <UiVideo
            v-if="category?.File?.MediaMobile?.url && category?.File?.MediaMobile?.mime?.includes('video')"
            class="mq--mobile-phablet"
            :src="category?.File?.MediaMobile?.url"
            :alt="category?.File?.MediaMobile?.alternativeText || category?.Name"
            :width="category?.File?.MediaMobile?.width"
            :height="category?.File?.MediaMobile?.height"
            :loading="lazy ? 'lazy' : 'eager'"
            :fetchpriority="lazy ? 'auto' : 'high'"
            :controls="false"
            autoplay
            muted
            loop
          />
        </div>
      </div>

      <div class="category__container">
        <div class="category__content">
          <!-- {{ category.ContentPosition }} -->

          <div
            v-if="category?.Title"
            class="category__heading heading heading--1"
          >
            {{ category.Title }}
          </div>
        </div>
      </div>
    </component>

    <!-- <pre>category: {{ category }}</pre> -->
  </article>
</template>

<script setup lang="ts">
import { AppLink } from '#components'

const props = withDefaults(defineProps<{
  category: any
  lazy: boolean
  categoryCount?: number
  fullWidth?: boolean
}>(), {
  categoryCount: 1,
  fullWidth: false,
})

const getElement = computed(() => {
  if (props?.category?.File?.Media?.mime?.includes('video')) {
    return 'div'
  }

  if (props?.category?.File?.Link) {
    return AppLink
  }

  return 'div'
})

const desktopImage = computed(() => {
  const maxWidth = 300
  const url = props?.category?.File?.Media?.url + '?f=rs:fit:' + maxWidth
  return url
})

const mobileImage = computed(() => {
  const maxWidth = 200
  const url = (props?.category?.File?.MediaMobile?.url || props?.category?.File?.Media?.url) + '?f=rs:fit:' + maxWidth
  return url
})
</script>

<style>
@import url("~layers/app/components/Strapi/Category.css");
</style>
